export class SeriesService {
    constructor(SeriesDomain) {
        this.SeriesDomain = SeriesDomain;
    }

    // Populate
    async populate(source, companyIds, origin) {
        await this.SeriesDomain.populateAccountsPlans({
            companyIds,
            source,
            origin
        });
    }

    getIds(source, companyId, origin, opts = {}) {
        const query = this._getQueryBySource(source, companyId, origin);
        let options = {};
        if (["accounting"].includes(source)) {
            options = {
                hierarchize: true,
                $associated: true,
                sort: { classifier: 1 }
            };
        }
        let accountsPlan = this.SeriesDomain.get(query, options, companyId);
        if (opts.rawSeries) {
            const rawSeries = this.SeriesDomain.get(
                {
                    companyId: query.companyId,
                    sources: query.sources,
                    "metadata.editMode": false,
                    type: "raw"
                },
                options,
                companyId
            );
            accountsPlan = [...accountsPlan, ...rawSeries];
        }
        return accountsPlan.map((s) => s._id);
    }

    getSeries(source, companyId, origin, opts = {}) {
        const query = this._getQueryBySource(
            source,
            companyId,
            origin,
            opts?.ignoreDisable || false
        );
        let options = {};
        if (["accounting"].includes(source)) {
            options = {
                hierarchize: true,
                $associated: true,
                sort: { classifier: 1 }
            };
        }
        let accountsPlan = this.SeriesDomain.get(query, options, companyId);
        if (opts.rawSeries) {
            const rawSeries = this.SeriesDomain.get(
                {
                    companyId: query.companyId,
                    sources: query.sources,
                    "metadata.editMode": false,
                    type: "raw"
                },
                options,
                companyId
            );
            accountsPlan = [...accountsPlan, ...rawSeries];
        }
        return accountsPlan;
    }

    getSeriesIds(series) {
        return series.map((serie) => serie._id);
    }

    _getQueryBySource(source, companyId, origin, disabled = false) {
        if (origin == "accountsPlanMonthly" && source == "accounting") {
            return {
                sources: "accounting",
                companyId: "EMPRESA_NUCONT",
                "metadata.accountsPlans": true
            };
        }

        let sourceAll = [
            "fin",
            "tax",
            "eSocial",
            "simplesNacional",
            "personnel"
        ].includes(source)
            ? "others"
            : source;
        if (disabled == true && sourceAll === "others") {
            sourceAll = "othersEditMode";
        }
        const queries = {
            custom: {
                $or: [
                    {
                        sources: "custom",
                        genus: { $in: ["synthetic", "analytic"] },
                        companyId: "EMPRESA_NUCONT"
                    },
                    {
                        sources: { $in: ["custom", "accounting"] },
                        companyIds: { $in: [companyId] }
                    }
                ]
            },
            accounting: {
                sources: "accounting",
                companyId: "EMPRESA_NUCONT",
                "metadata.isPublicAccountsPlan": true
            },
            financial: {
                sources: "financial",
                companyId: "EMPRESA_NUCONT",
                "metadata.isPublicAccountsPlan": true
            },
            others: {
                companyId,
                sources: source,
                "metadata.editMode": true,
                "metadata.disabled": false
            },
            othersEditMode: {
                companyId,
                sources: source,
                "metadata.editMode": true
            }
        };

        return queries[sourceAll];
    }

    getByByIds(seriesIds) {
        seriesIds = [].concat(seriesIds);
        if (!seriesIds || !seriesIds.length) return [];
        let series = this.SeriesDomain.get({ _id: { $in: seriesIds } });
        if (!series?.length)
            series = this.SeriesDomain.get({ referenceId: { $in: seriesIds } });
        const seriesIn = [];
        seriesIds.forEach((_id, i) => {
            let serie = series.find((s) => {
                return [s._id].includes(_id);
            });
            if (!serie) {
                serie = series.find((s) => {
                    return [s.referenceId].includes(_id);
                });
            }
            if (
                !serie ||
                (serie?.metadata?.origin === "goals" &&
                    serie?.metadata?.disabled === false)
            )
                return;
            serie.i = i;
            seriesIn.push(serie);
        });
        return seriesIn;
    }

    getGoalsIds({ source, series, visualization } = {}) {
        if (source === "accounting") {
            return series
                .filter((s) => s?.metadata?.origin === "goals")
                .map((s) => s._id);
        }
        return visualization?.goals?.map((g) => g.r);
    }
}
